/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: TypingActivityHandler
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler 
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.TypingActivityHandler = function() {
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(this,com.inq.flash.client.data.MessageFields.TYPE_CHAT_ACTIVITY);
	this.sAgentIsTyping = com.inq.utils.Util.getConfig("sAgentIsTyping","Agent is typing");
	this.sAgentStoppedTyping = com.inq.utils.Util.getConfig("sAgentStoppedTyping","Agent stopped typing");
};
$hxClasses['com.inq.flash.client.control.messagehandlers.TypingActivityHandler'] = com.inq.flash.client.control.messagehandlers.TypingActivityHandler;
/** @private @type {Array} */
com.inq.flash.client.control.messagehandlers.TypingActivityHandler.__name__ = ["com","inq","flash","client","control","messagehandlers","TypingActivityHandler"];
/** @private @type {Function} */
com.inq.flash.client.control.messagehandlers.TypingActivityHandler.__super__ = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler;
for(var k in com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype ) com.inq.flash.client.control.messagehandlers.TypingActivityHandler.prototype[k] = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype[k];

com.inq.flash.client.control.messagehandlers.TypingActivityHandler.prototype.processMessage = function(message) {
	/** @type {com.inq.flash.client.chatskins.ChatTextArea} */
	var cw = com.inq.flash.client.chatskins.SkinControl.cw;
	switch(message.getProperty(com.inq.flash.client.data.MessageFields.KEY_TYPE)) {
		case com.inq.flash.client.data.MessageFields.ACTIVITY_AGENT_TYPING:
			if(null != cw) cw.addTranscript("",this.sAgentIsTyping,com.inq.flash.client.chatskins.ChatTextArea.SYSTEM_STATUS,-1);
			break;
		case com.inq.flash.client.data.MessageFields.ACTIVITY_AGENT_STOPPED_TYPING:
			if(null != cw) cw.addTranscript("",this.sAgentStoppedTyping,com.inq.flash.client.chatskins.ChatTextArea.SYSTEM_STATUS,-1);
			break;
		case com.inq.flash.client.data.MessageFields.ACTIVITY_CUSTOMER_TYPING:
			com.inq.flash.client.chatskins.SkinControl.userWasTyping = true;
			break;
		case com.inq.flash.client.data.MessageFields.ACTIVITY_CUSTOMER_STOPS_TYPING:
			com.inq.flash.client.chatskins.SkinControl.userWasTyping = false;
			break;
	}
    com.inq.flash.client.chatskins.FormMgr.updateFormTimeExecutor(cw);
};

/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.TypingActivityHandler.prototype.sAgentIsTyping = null;
/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.TypingActivityHandler.prototype.sAgentStoppedTyping = null;
/** @private @type {boolean} */
com.inq.flash.client.control.messagehandlers.TypingActivityHandler.prototype.isEnabled = null;
/** @private @type {null} */
com.inq.flash.client.control.messagehandlers.TypingActivityHandler.prototype.needwaitPeriod = null;
/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.TypingActivityHandler.prototype.needwaitMessage = null;
/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.TypingActivityHandler.prototype.needwaitMessageFirst = null;
/** @private @type {number} */
com.inq.flash.client.control.messagehandlers.TypingActivityHandler.prototype.cntMessage = null;
/** @type {com.inq.flash.client.control.messagehandlers.TypingActivityHandler} */
com.inq.flash.client.control.messagehandlers.TypingActivityHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.TypingActivityHandler;
